<template>
    <div>
        <app-sub-title :text="`Creación sede cliente ${client.name}`" />
        <b-card
            title="Información básica"
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="6">
                        <app-form-text-input
                            label="Nombre"
                            id="name"
                            :required="true"
                            :hasError="$v.theVenue.name.$error"
                            errorMessage="Debe escribir el nombre"
                            @input="$v.theVenue.name.$touch()"
                            v-model="theVenue.name"
                        />
                    </b-col>
                    <b-col cols="12" md="6">
                        <app-form-select
                            label="Ciudad"
                            :options="selectableCities"
                            v-model="theVenue.cityId"
                            @change="$v.theVenue.cityId.$touch()"
                            :has-error="$v.theVenue.cityId.$error"
                            error-message="Debe seleccionar la ciudad"
                            required
                            value-field="id"
                            text-field="name"
                        ></app-form-select>
                    </b-col>
                    <b-col cols="12">
                        <app-form-text-input
                            label="Dirección"
                            id="address"
                            v-model="theVenue.address"
                        />
                    </b-col>
                    <b-col cols="12" md="12">
                        <app-form-textarea-input
                            label="Descripción"
                            id="description"
                            v-model="theVenue.description"
                        />
                    </b-col>
                    <!-- <b-col>
                        <div class="pull-right">
                            <b-button @click="saveVenue" variant="primary">Guardar</b-button>
                        </div>
                    </b-col>                  -->
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import venuesRepository from "../../../../repositories/venues.repository.js";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
    props: {
        theClient: {
            type: Object,
            required: true
        },
        onSave: {
            type: Function
        },
        myVenue: {
            default: null
        }
    },

    data() {
        return {
            theVenue: {
                name: "",
                address: "",
                description: "",
                clientId: "",
                cityId: ""
            }
        };
    },
    validations: {
        theVenue: {
            name: { required },
            cityId: { required }
        }
    },
    watch: {
        myVenue(val) {
            this.fillForm();
        }
    },
    computed: {
        ...mapGetters(["cities"]),
        selectableCities() {
            return this.cities.filter(city => !!city.company_presence);
        }
    },
    methods: {
        saveVenue() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }
            this.theVenue.clientId = this.theClient.id;

            const vr = { ...venuesRepository };
            vr.saveVenue(this.theVenue)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanForm();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al guardar la sede");
                });
        },
        updateVenue(id) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const vr = { ...venuesRepository };
            vr.updateVenue(this.theVenue, this.myVenue.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanForm();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al actualizar la sede");
                });
        },
        saveOrUpdate() {
            if (!!this.myVenue) {
                this.updateVenue();
            } else {
                this.saveVenue();
            }
        },
        fillForm() {
            if (Object.keys(this.myVenue).length !== 0) {
                this.theVenue.name = this.myVenue.name;
                this.theVenue.address = this.myVenue.address;
                this.theVenue.description = this.myVenue.description;
                this.theVenue.cityId = this.myVenue.city_id;
            } else {
                this.cleanForm();
            }
        },
        cleanForm() {
            Object.keys(this.theVenue).map(key => (this.theVenue[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },
    mounted() {
        this.load("cities");
        this.$bus.$on("venue-form.save", this.saveOrUpdate);
        this.$bus.$on("venue-form.clean", this.cleanForm);
    },

    beforeDestroy() {
        this.$bus.$off("venue-form.save");
    }
};
</script>
